import React from 'react';
import { principles } from '../../data/site';
import { Eyebrow } from '../ui/Eyebrow';
export function Principles() {
  return <section className="bg-ink text-cream" data-id="element-90" data-mp="1zv7afv0yr5r2">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-91" data-mp="24tiiq1bm1876">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-92" data-mp="24s7gw71q6aip">
          <div data-id="element-93" data-mp="28vvkyfr5enz7">
            <Eyebrow className="text-cream/70" data-id="element-94" data-mp="28wf4u20czmfv">What Republic stands on</Eyebrow>
            <p className="mt-6 font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-95" data-mp="2dtdzclnxpvel">
              More choice is better health for all.
            </p>
          </div>

          <ul className="flex flex-col divide-y divide-cream/20" data-id="element-96" data-mp="2njgpme3o8v98">
            {principles.map(principle => <li key={principle.name} className="grid gap-2 py-6 first:pt-0 sm:grid-cols-[10rem_1fr] sm:gap-8" data-id="element-97" data-mp="2sjcwcl3r70sh">
                <h3 className="font-serif text-2xl text-cream" data-id="element-98" data-mp="31jrfpex5q5tc">{principle.name}</h3>
                <p className="max-w-xl text-base leading-relaxed text-cream/75" data-id="element-99" data-mp="31hour9av32vh">
                  {principle.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}